import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import TranslationHelper from '../common/TranslationHelper';

import '../css/admin/css/style.css';

export default class NotFound extends React.Component {
	render() {
		const style = this.props.missingPackage ? { marginTop: '175px' } : { marginTop: '175px', position: 'relative' };
		return (
			<div className="error m-b-10 error-code" style={style}>
				<div>
					{TranslationHelper.getValue('customer_account.404.pageLoading')}
					<i className="fa fa-warning" />
					<div className="flex-center">
						<CircularProgress />
					</div>
				</div>

				<div>
					<a href="/" className="btn btn-success">
						{TranslationHelper.getValue('customer_account.404.backToHomePage')}
					</a>
				</div>
			</div>
		);
	}
}
